function Rwanda({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1976)">
  <path d="M0 16.0007C0 18.7726 0.705188 21.3797 1.94544 23.6529L16 25.0442L30.0546 23.6529C31.2948 21.3797 32 18.7726 32 16.0007L16 14.6094L0 16.0007Z" fill="#FFDA44"/>
  <path d="M30.0546 8.34781C27.3409 3.37431 22.0647 0 16 0C9.93531 0 4.65912 3.37431 1.94544 8.34781C0.705188 10.621 0 13.2281 0 16H32C32 13.2281 31.2948 10.621 30.0546 8.34781Z" fill="#338AF3"/>
  <path d="M16 32.0002C22.0647 32.0002 27.3409 28.6258 30.0545 23.6523H1.94543C4.65912 28.6258 9.93531 32.0002 16 32.0002Z" fill="#496E2D"/>
  <path d="M18.0869 9.36358L20.041 10.2828L19.0005 12.1753L21.1224 11.7694L21.3912 13.9128L22.8691 12.3363L24.3471 13.9128L24.6159 11.7694L26.7378 12.1751L25.6973 10.2827L27.6513 9.36358L25.6972 8.44452L26.7378 6.55202L24.616 6.95789L24.347 4.81445L22.8691 6.39095L21.3912 4.81445L21.1224 6.95789L19.0004 6.55202L20.041 8.44458L18.0869 9.36358Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Rwanda;
